import { render, staticRenderFns } from "./ProductsScreen.vue?vue&type=template&id=26046bb0&"
import script from "./ProductsScreen.vue?vue&type=script&lang=js&"
export * from "./ProductsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports